module.exports = __webpack_public_path__ + "img/apple-store-it-white.5b953459.svg";